import {
  IFormInputValidatedProps,
  IFormItemWrapperProps,
  multipleValidators,
  Validators,
} from '@main/core-ui';
import { DefinedMessage } from '@main/internationalization';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { emailFormInputMessages } from './messages';
import { FormItemTitleWrapper, StyledFormInput } from './wrappers';

export const EmailFormInput: React.FC<
  IFormInputValidatedProps &
    Omit<IFormItemWrapperProps, 'errors'> & {
      /** disabled */
      disabled?: boolean;
      /** Title style */
      titleStyle?: React.CSSProperties;
      /** Title for the input */
      title?: DefinedMessage;
      /** placeholder for the input */
      placeholder?: DefinedMessage;
    }
> = ({ name, titleStyle, title, placeholder, ...rawInputProps }) => {
  const { control } = useFormContext();
  const { formatMessage } = useIntl();

  return (
    <>
      {title && (
        <FormItemTitleWrapper style={titleStyle}>
          {formatMessage(title)}
        </FormItemTitleWrapper>
      )}
      <>
        <Controller
          name={name}
          control={control}
          rules={{
            validate: multipleValidators([
              Validators.REQUIRED,
              Validators.EMAIL,
            ]),
          }}
          render={({ field: { ref: {} = {}, ...props } }) => (
            <StyledFormInput
              type="email"
              placeholder={formatMessage(
                placeholder || emailFormInputMessages.emailPlaceholder,
              )}
              {...props}
              {...rawInputProps}
            />
          )}
        />
      </>
    </>
  );
};
